import { useState } from 'react';
import { openBlob } from '../Utils/fileDownloadUtils';
import { getAuthenticatedClient } from '../Utils/tokenHelper';
import { useAccount, useMsal } from '@azure/msal-react';
import { enableFrontdoor } from '../Utils/features';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_EOB_API_BASE_URL_FRONTDOOR : process.env.REACT_APP_EOB_API_BASE_URL;

export default function useGenerateEobApi() {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0]);

    const executeRequest = async (request, fileName) => {
        setLoading(true);
        setSuccess(false);
        setError(null);

        try {
            const { data } = await (await getAuthenticatedClient({
                url: `${BASE_URL}/generate/eob`,
                method: 'POST',
                body: request,
                responseType: 'blob',
                msalInstance: instance, 
                account
            }));
    
            const blob = new Blob([data], { type: 'application/pdf', });
            openBlob(blob, true, true, `${fileName}.pdf`);
            setSuccess(true);
        } catch(e) {
            console.error(e);
            setError(e);
        } finally {
            setLoading(false);
        }
    }

    const executeReset = () => {
        setLoading(false);
        setSuccess(false);
        setError(null);
    }

    return [
        loading,
        success,
        error,
        executeRequest,
        executeReset
    ];
};
